/**
 * @desc 通过BPM开启流程
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.ActivitiProcessInstanceDto>;
export function request(
  body: defs.activiti.BpmActivitiStartBusinessDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/startProcessInstanceRouteBpm`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
